import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SmsAuthWithPhoneSwitch = _resolveComponent("SmsAuthWithPhoneSwitch")!
  const _component_PhoneAuth = _resolveComponent("PhoneAuth")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isSms)
      ? (_openBlock(), _createBlock(_component_SmsAuthWithPhoneSwitch, {
          key: 0,
          title: "電話番号認証",
          phoneNumber: _ctx.phoneNumber,
          createSms: _ctx.createSms,
          validateSms: _ctx.validateSms,
          onSwitchToVoice: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchProvider('phone'))),
          onValidated: _ctx.onValidated
        }, null, 8, ["phoneNumber", "createSms", "validateSms", "onValidated"]))
      : (_ctx.isVoice)
        ? (_openBlock(), _createBlock(_component_PhoneAuth, {
            key: 1,
            title: "電話番号認証",
            phoneNumber: _ctx.phoneNumber,
            createPhoneRequest: _ctx.createPhoneRequest,
            validatePhoneRequest: _ctx.validatePhoneRequest,
            onSwitchToSMS: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchProvider('sms'))),
            onValidated: _ctx.onValidated
          }, null, 8, ["phoneNumber", "createPhoneRequest", "validatePhoneRequest", "onValidated"]))
        : _createCommentVNode("", true)
  ]))
}